import {workspaceIcon, type WorkspaceIcon} from './workspace-icons';

export function element<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className = '',
  text = '',
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  node.className = className;
  if (text) node.textContent = text;
  return node;
}

export function button(label: string, className = 'button'): HTMLButtonElement {
  const node = element('button', className, label);
  node.type = 'button';
  return node;
}

export function iconButton(label: string, icon: WorkspaceIcon): HTMLButtonElement {
  const node = button('', 'icon-button');
  node.ariaLabel = label;
  node.title = label;
  node.append(workspaceIcon(icon));
  return node;
}

export function debounce(callback: () => void, delay: number): () => void {
  let timeout = 0;
  return () => {
    clearTimeout(timeout);
    timeout = window.setTimeout(callback, delay);
  };
}

export function announce(message: string, tone: 'neutral' | 'success' | 'error' = 'neutral') {
  const toast = element('div', `toast toast-${tone}`, message);
  document.body.append(toast);
  requestAnimationFrame(() => toast.classList.add('is-visible'));
  setTimeout(() => {
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 250);
  }, 2_400);
}
